import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Main from './components/Main';

export default ({ children }) => {
  return (
    <>
      <Header />
      <Main>{children}</Main>
      <Footer />
    </>
  );
};
